import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from '@mui/material';

const AddJourneyStepDialog = ({
  open,
  onClose,
  onSave,
  stepType,
  initialName = '',
}) => {
  const [name, setName] = useState(initialName);
  const [config, setConfig] = useState({});
  const [template, setTemplate] = useState(null);

  const handleSave = () => {
    const stepData = {
      name,
      step_type: stepType,
      config: Object.keys(config).length > 0 ? config : null,
      template: template,
    };
    onSave(stepData);
    onClose();
  };

  const renderConfigFields = () => {
    switch (stepType) {
      case 'email':
      case 'sms':
      case 'voice':
      case 'chat':
        return (
          <>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.primary" gutterBottom>
                Message Source
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={template ? 'template' : 'direct'}
                  onChange={(e) => {
                    if (e.target.value === 'template') {
                      setTemplate(null);
                      setConfig({});
                    } else {
                      setTemplate(null);
                      setConfig({ content: '' });
                    }
                  }}
                >
                  <MenuItem value="template">Use Template</MenuItem>
                  <MenuItem value="direct">Direct Message</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {template ? (
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="text.primary" gutterBottom>
                  Template
                </Typography>
                <FormControl fullWidth>
                  <Select
                    value={template || ''}
                    onChange={(e) => setTemplate(e.target.value)}
                  >
                    <MenuItem value="">Select a template</MenuItem>
                    {/* Template options will be populated from API */}
                  </Select>
                </FormControl>
              </Box>
            ) : (
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="text.primary" gutterBottom>
                  Message Content
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  value={config.content || ''}
                  onChange={(e) => setConfig({ ...config, content: e.target.value })}
                  placeholder="Enter your message content"
                />
              </Box>
            )}
          </>
        );

      case 'wait_step':
        return (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="text.primary" gutterBottom>
              Wait Duration
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                type="number"
                label="Duration"
                value={config.duration || ''}
                onChange={(e) => setConfig({ ...config, duration: parseInt(e.target.value) })}
                sx={{ flex: 1 }}
              />
              <FormControl sx={{ flex: 1 }}>
                <InputLabel>Unit</InputLabel>
                <Select
                  value={config.unit || 'seconds'}
                  onChange={(e) => setConfig({ ...config, unit: e.target.value })}
                  label="Unit"
                >
                  <MenuItem value="seconds">Seconds</MenuItem>
                  <MenuItem value="minutes">Minutes</MenuItem>
                  <MenuItem value="hours">Hours</MenuItem>
                  <MenuItem value="days">Days</MenuItem>
                  <MenuItem value="weeks">Weeks</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        );

      case 'validation_step':
        return (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="text.primary" gutterBottom>
              Validation Type
            </Typography>
            <FormControl fullWidth>
              <Select
                value={config.validation_type || 'field_check'}
                onChange={(e) => setConfig({ ...config, validation_type: e.target.value })}
              >
                <MenuItem value="field_check">Field Check</MenuItem>
                <MenuItem value="custom_validation">Custom Validation</MenuItem>
              </Select>
            </FormControl>
          </Box>
        );

      case 'webhook':
        return (
          <>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.primary" gutterBottom>
                Webhook URL
              </Typography>
              <TextField
                fullWidth
                value={config.url || ''}
                onChange={(e) => setConfig({ ...config, url: e.target.value })}
                placeholder="https://api.example.com/webhook"
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.primary" gutterBottom>
                HTTP Method
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={config.method || 'POST'}
                  onChange={(e) => setConfig({ ...config, method: e.target.value })}
                >
                  <MenuItem value="GET">GET</MenuItem>
                  <MenuItem value="POST">POST</MenuItem>
                  <MenuItem value="PUT">PUT</MenuItem>
                  <MenuItem value="DELETE">DELETE</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Configure Step</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" color="text.primary" gutterBottom>
            Step Name
          </Typography>
          <TextField
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter step name"
            sx={{ mb: 3 }}
          />
          {renderConfigFields()}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleSave} 
          variant="contained"
          disabled={!name}
        >
          Add Step
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddJourneyStepDialog; 